"use client";

import { useRouter as useNextRouter } from "next/navigation";

export function useRouter() {
	return useNextRouter();
}
